export default __webpack_public_path__ + "static/media/img-0522-norway-full-face.2b186cd7.png";